var nameRegExp = /[\s\S]*/i;
export default (function (value) {
  var error = nameRegExp.test(value) ? '' : 'Name is invalid';
  return error;
});